import { Blockquote } from '@ui';
import Loader from 'components/Loader';
import useCheckPermissions from 'hooks/useCheckPermissions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SecuredAreaWarning from '~/components/auth/SecuredAreaWarning';

interface Props {
    clubSlug?: string;
    permission: string | string[];
    redirect?: string;
    delay?: number;
    children?: React.ReactNode;
}

export const CheckAccess: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
    clubSlug,
    permission,
    // redirect,
    // delay = 3000,
    children
}) => {
    const { isLoading, isAuthenticated, permissionError, data } = useCheckPermissions({ clubSlug, permission });

    return (
        <Loader isLoading={isLoading && clubSlug !== undefined}>
            {isAuthenticated && !permissionError ? (
                children
            ) : (
                <div className="tw-flex tw-h-full tw-flex-auto tw-items-center tw-justify-center">
                    <div className="tw-w-full lg:tw-w-2/3">
                        {!isAuthenticated ? (
                            <SecuredAreaWarning />
                        ) : permissionError ? (
                            <AccessDeniedInfo message={data.message} missingPermissions={data.missing_permissions} />
                        ) : null}
                    </div>
                </div>
            )}
        </Loader>
    );
};

const AccessDeniedInfo = ({ message, missingPermissions }: { message: string; missingPermissions: string[] }) => {
    const { t } = useTranslation('general');

    return (
        <Blockquote title={t('permissions.checkAccess.title')} color="error">
            <p>{message}</p>
            <span className="tw-font-semibold">{t('permissions.checkAccess.requiredPermissions')}</span>
            <ul className="tw-mb-0 tw-pl-4 tw-text-xs">
                {missingPermissions.map((permission) => (
                    <li key={permission}>{permission}</li>
                ))}
            </ul>
        </Blockquote>
    );
};
